import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()
        this.url = process.env.REACT_APP_KECLOACK_URL
    }

    loginUser(userName, password) {
        let formData = new URLSearchParams()
        formData.append("username", userName)
        formData.append("password", password)
        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", this.httpClient.getClientSecret())
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })


        })

    }


    getUserTokenByRefreshToken(refreshToken) {

        let formData = new URLSearchParams()
        formData.append("refresh_token", refreshToken)
        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", this.httpClient.getClientSecret())
        formData.append("grant_type", "refresh_token")

        return new Promise((resolve, reject) => {

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })


        })
    }

    getAccessInfo(token) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/admins/access-information`,
                {},
                {
                    "Authorization": this.httpClient.convertToken(token),
                    'Content-Type': "application/json"
                }
            ).then(resolve).catch(reject)
        })
    }

}